import React from 'react';
import styles from '../../../styles/ViewListing.module.css';
import type { ListingDocument } from '../../../types/ListingTypes';
import { downloadFile } from '../../../utils/fileUtils';

interface DetailProps {
    documents: ListingDocument[];
}

const ListingDocuments: React.FC<DetailProps> = ({ documents }) => {
    return (
        <section className={styles.section}>
            <p className={styles.sectionTitle}>Documents</p>
            {documents.length === 0 ? (
                <p className={styles.empty}>No documents uploaded yet.</p>
            ) : (
                <div className={styles.docList}>
                    {documents.map((doc: ListingDocument) => (
                        <div key={doc.id} className={styles.docRow}>
                            <div className={styles.docRowLeft}>
                                <span className={styles.docName}>{doc.name}</span>
                                {doc.documentType && (
                                    <span className={styles.docType}>{doc.documentType.name}</span>
                                )}
                                <span className={styles.docDate}>
                                    Uploaded {new Date(doc.createdAt).toLocaleDateString('en-ZA')}
                                </span>
                            </div>
                            {doc.url && (
                                <button
                                    className={styles.downloadBtn}
                                    onClick={e => { e.stopPropagation(); downloadFile(doc.url!, doc.name); }}
                                    title="Download"
                                >
                                    ↓
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
};

export default ListingDocuments;